import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { CaptchaService } from './services/captcha/captcha.service';
import { FlowService } from './services/flow/flow.service';
import { StorageService } from './services/Storage/storage.service';
import { AppRouteChangeServiceService } from './app-route-change-service.service';
import { WebtrendsService } from './services/webtrends/webtrends.service';
// import { LoggerApiService } from './services/logger/logger-api.service';
import { BrazeService } from './services/braze/braze.service';
import { LoggerApiService } from './services/logger/logger-api.service';
import { NetworkStatusService } from './shared/services/network-status/network-status.service';

declare function callOutJsProgress(value: any): any;
declare var braze: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'BundleSales';
  public isLoading: boolean;
  public isShowCaptcha: boolean = false;
  IsShowCaptcha: Subscription;
  private offlineStartTime: Date | null = null;
  private onlineListener: (() => void) | null = null;

  constructor(
    private appRouteChangeService: AppRouteChangeServiceService,
    private webtrendsService: WebtrendsService,
    private captchaService: CaptchaService,
    public flowservice: FlowService,
    public storage: StorageService,
    public router: Router,
    brazeService: BrazeService,
    private loggerApi: LoggerApiService,
    private networkStatus: NetworkStatusService
  ) {
    this.loggerApi.sendEventLog({
      event: 'app load',
      timestamp: new Date(),
      url: window.location.href,
      entry: this.storage.getEntry(),
      token: this.storage.getToken()
    });
    
    this.appRouteChangeService.listenToRouterEvents();
    brazeService.initBraze();

    window.addEventListener('error', (event) => {
      // console.error("Global error caught via addEventListener:", event.error);
      // You can access more details from the event object, similar to window.onerror
      this.loggerApi.sendEventLog({
        event: 'client_global_error',
        errorEvent: event,
        error: event?.error,
        errorMessage: event.error?.message || 'Unknown error',
        stack: event.error?.stack || 'No stack trace available',
        token: this.storage.getToken(),
        url: window.location.href,
        timestamp: new Date()
      });
    });

    this.networkStatus.onlineStatus$.subscribe(isOnline => {
      console.log('Network status changed. Is online:', isOnline);
      if (!isOnline) {
        this.offlineStartTime = new Date();
      }
      if (isOnline) {
        const onlineTime = new Date();
        this.loggerApi.sendEventLog({
          event: 'network_regained',
          message: 'The application has regained network connectivity.',
          url: window.location.href,
          offlineStartTime: this.offlineStartTime,
          timestamp: onlineTime,
          token: this.storage.getToken()
        });
        this.offlineStartTime = null;
      }
    });
  }

  ngOnInit() {
    this.isLoading = false;

    setTimeout(() => {
      let scrollbarvalue = this.storage.getSessionValue('lastscrollbar_value'); //
      callOutJsProgress(scrollbarvalue);
    }, 250);

    if (!environment.isLocal) {
      this.checkHTTPS();
    }

    // if (!environment.production || !environment.showCaptcha) {
    if (!environment.showCaptcha && !environment.showCaptchaPhase1) {
      this.isShowCaptcha = false;
    } else {
      this.IsShowCaptcha = this.captchaService.getCaptchaState().subscribe(state => {
        setTimeout(() => {
          console.log('state: ', state);
          // console.log('IsValidateReCaptcha', environment.IsValidateReCaptcha)
          const currentUrl = window.location.href.toLowerCase();
          const isInFirstScreen = currentUrl.includes('personalinformation') || currentUrl.includes('identitynumber') || currentUrl.includes('idphone');
          this.isShowCaptcha = state && ((isInFirstScreen && environment.showCaptchaPhase1) ? true : environment.showCaptcha);
        }, 300);
      });
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onWindowBeforeUnload($event) {
    this.storage.saveRefreshed(true);
    // Log before submit
    // this.loggerApi.sendBeaconLog({
    //   event: 'on beforeunload - probably refresh or close',
    //   timestamp: new Date(),
    //   url: window.location.href,
    //   entry: this.storage.getEntry(),
    //   token: this.storage.getToken(),
    //   closeType: 'unknown'
    // });
  }

  @HostListener('window:unload', ['$event'])
  onWindowUnload($event) {
    // Log before submit
    let closeType = this.storage.getRefreshed() ? 'refresh' : 'close';
    // this.loggerApi.sendBeaconLog({
    //   event: 'unload - close or refresh, probably ' + (closeType == 'refresh' ? ' - refresh' : ' - close'  ),
    //   timestamp: new Date(),
    //   url: window.location.href,
    //   entry: this.storage.getEntry(),
    //   token: this.storage.getToken(),
    //   closeType: closeType
    // });
    try {
      // web trends
      this.webtrendsService.sendWebTrends({
        action: 'closed window or refreshed page on - ' + document.URL,
        id_number: this.storage.getSessionValue('identityNumber'),
        HativaPratit:  'closed window or refreshed page on - ' + document.URL,
        phone_number: this.storage.getSessionValue('MobilePhoneNumber'),
        fullName: this.storage.getSessionValue('FullName'),
        vas: this.storage.getSelectedVasses().join(','),
        email: this.storage.getSessionValue('Email'),
      });
    } catch(ex) {
      console.log(ex);
    }
  }

  checkHTTPS() {
    const locationProtocol = location.protocol.split(':')[0];
    if (locationProtocol.toLowerCase() !== 'https') {
      location.protocol = 'https:';
      return;
    }
  }
  
}
